import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useMSPowerBIDatasourceRepo from '@/composables/integrations/ms-powerbi/ms-powerbi-datasource-repo';
import useRepo from '@/nebula/repo';
import { customDatasourceProperty } from 'shared/constants.json';
import { msPowerBiQuery as msPowerBiQueryConfig } from 'shared/api/query/configs.json';

export default function useMSPowerBI() {
  const queryRepo = useRepo(msPowerBiQueryConfig.model);
  const datasourceRepo = useMSPowerBIDatasourceRepo();

  const { loggedInUser } = useLoggedInUser();

  const createQuery = (entity) => queryRepo.createSingle({
    ...entity,
    creator: { uid: loggedInUser.value.uid },
  });

  const getDatasetsInGroup = (datasource, group) => datasourceRepo.getSingle({
    ...datasource,
    [customDatasourceProperty.msPowerBiGroups]: [group],
  });

  return {
    createQueryLoading: queryRepo.createLoading,
    createQuery,
    updateQueryLoading: queryRepo.updateLoading,
    updateQuery: (entity) => queryRepo.updateSingle(entity, { ignoreResponse: false }),
    deleteQueryLoading: queryRepo.deleteLoading,
    deleteQuery: queryRepo.deleteSingle,
    getDatasetsInGroupLoading: datasourceRepo.getSingleLoading,
    getDatasetsInGroup,
  };
}
